module.exports = __webpack_public_path__ + "static/media/small-blue-button.3c9b129e.svg";